module.exports = "/fonts/vendor/typeface-inter/files/inter-latin-800.woff2?299c8ff514e2c5c46cda1a0cd0905176";